import React from 'react';
import './InfoPage.css';

const TermsOfService = () => {
  return (
    <div className="info-page">
      <div className="info-container">
        <h1>Terms of Service</h1>
        <p className="last-updated">Last updated: {new Date().toLocaleDateString()}</p>

        <section>
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing and using VIT CGPA Calculator, you accept and agree to be bound by the terms and 
            provision of this agreement. If you do not agree to these terms, please do not use our service.
          </p>
        </section>

        <section>
          <h2>2. Use License</h2>
          <p>
            Permission is granted to temporarily use VIT CGPA Calculator for personal, non-commercial use. 
            This is the grant of a license, not a transfer of title, and under this license you may not:
          </p>
          <ul>
            <li>Modify or copy the materials</li>
            <li>Use the materials for any commercial purpose</li>
            <li>Attempt to reverse engineer any software contained on the website</li>
            <li>Remove any copyright or other proprietary notations from the materials</li>
          </ul>
        </section>

        <section>
          <h2>3. Disclaimer</h2>
          <p>
            The materials on VIT CGPA Calculator are provided on an 'as is' basis. We make no warranties, 
            expressed or implied, and hereby disclaim and negate all other warranties including, without 
            limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, 
            or non-infringement of intellectual property or other violation of rights.
          </p>
        </section>

        <section>
          <h2>4. Limitations</h2>
          <p>
            In no event shall VIT CGPA Calculator or its suppliers be liable for any damages (including, 
            without limitation, damages for loss of data or profit, or due to business interruption) arising 
            out of the use or inability to use the materials on our website.
          </p>
        </section>

        <section>
          <h2>5. Accuracy of Materials</h2>
          <p>
            The materials appearing on VIT CGPA Calculator could include technical, typographical, or 
            photographic errors. We do not warrant that any of the materials on its website are accurate, 
            complete, or current. We may make changes to the materials contained on its website at any time 
            without notice.
          </p>
        </section>

        <section>
          <h2>6. Links</h2>
          <p>
            We have not reviewed all of the sites linked to our website and are not responsible for the 
            contents of any such linked site. The inclusion of any link does not imply endorsement by us 
            of the site. Use of any such linked website is at the user's own risk.
          </p>
        </section>

        <section>
          <h2>7. Modifications</h2>
          <p>
            We may revise these terms of service for its website at any time without notice. By using this 
            website you are agreeing to be bound by the then current version of these terms of service.
          </p>
        </section>

        <section>
          <h2>8. Governing Law</h2>
          <p>
            These terms and conditions are governed by and construed in accordance with applicable laws. 
            Any disputes relating to these terms shall be subject to the exclusive jurisdiction of the 
            courts in the applicable jurisdiction.
          </p>
        </section>

        <section>
          <h2>9. User Responsibilities</h2>
          <p>Users are responsible for:</p>
          <ul>
            <li>Maintaining the confidentiality of their account information</li>
            <li>All activities that occur under their account</li>
            <li>Ensuring the accuracy of data entered into the calculator</li>
            <li>Using the service in compliance with all applicable laws</li>
          </ul>
        </section>

        <section>
          <h2>10. Contact Information</h2>
          <p>
            If you have any questions about these Terms of Service, please contact us through our website.
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsOfService;

